import {
    OnboardingTutorialNavigationMarkerStyled,
    OnboardingTutorialNavigationPaginationStyled,
    OnboardingTutorialNavigationStyled,
} from "./styled/OnboardingTutorialNavigationStyled";
import classNames from "classnames";
import {useOnboardingTutorialContext} from "../../onboardingTutorialContext";
import {OnboardingTutorialStepBackButton} from "../OnboardingTutorialStepBackButton/OnboardingTutorialStepBackButton";

export const OnboardingTutorialNavigation = () => {
    const {currentStep, stepsCount} = useOnboardingTutorialContext();
    const isShowPreviousButton = currentStep !== 0;
    return (
            <OnboardingTutorialNavigationStyled className={classNames({
                'justify-content-between': isShowPreviousButton,
                'justify-content-center': !isShowPreviousButton,
            })}>
                {isShowPreviousButton && <OnboardingTutorialStepBackButton/>}
                <OnboardingTutorialNavigationPaginationStyled>
                    {
                        Array.from({ length: stepsCount }).map((item, index) => (
                                <OnboardingTutorialNavigationMarkerStyled key={index} className={classNames('ms-1', {
                                    'active': currentStep === index
                                })}/>
                        ))
                    }
                </OnboardingTutorialNavigationPaginationStyled>
            </OnboardingTutorialNavigationStyled>
    )
}
